export namespace PaymentAccountErrorConstants {
  export const CREDIT_CARD_EXPIRATION_IS_PAST: RegExp = /The Credit Card expiration date is in the past/;
  export const LAST_PAYMENT_ACCOUNT_CANNOT_BE_DELETED: RegExp =
    /The last payment account for rider = \[.*\] cannot be deleted because they have pending payments on a ride/;
  export const COULD_NOT_CREATE_PAYMENT_ACCOUNT: RegExp = /Could not verify ACH payment account/;
  export const TRANSACTION_DECLINED: RegExp = /This transaction has been declined/;
  export const DUPLICATE_TRANSACTION: RegExp = /A duplicate transaction has been submitted/;
  export const DUPLICATE_PAYMENT_ACCOUNT: RegExp = /Error: PaymentAccount already on file/;
}
